
export { defaultEnv } from "./configuration/next-env"